import { render, staticRenderFns } from "./HouseForm.vue?vue&type=template&id=ec053aaa"
import script from "./HouseForm.vue?vue&type=script&lang=js"
export * from "./HouseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports